import React, { useState } from "react";

const ClientSelector = ({ users, selectedClients, setSelectedClients }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const toggleClient = (userId) => {
    if (selectedClients.includes(userId)) {
      setSelectedClients(selectedClients.filter((id) => id !== userId));
    } else {
      setSelectedClients([...selectedClients, userId]);
    }
  };

  const filteredUsers = users.filter(
    (user) =>
      user.displayName &&
      user.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        className="w-full p-2 border rounded-lg mb-4"
        placeholder="Search clients..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {searchTerm && (
        <div className="flex flex-wrap gap-4">
          {filteredUsers.map((user) => (
            <div
              key={user.id}
              className={`cursor-pointer p-2 border rounded-lg flex items-center gap-2 ${
                selectedClients.includes(user.id)
                  ? "bg-blue-100 border-blue-500"
                  : "border-gray-300"
              }`}
              onClick={() => toggleClient(user.id)}
            >
              <img
                src={user.profileImage || "https://via.placeholder.com/40"}
                alt={user.displayName}
                className="w-8 h-8 rounded-full object-cover"
              />
              <span>{user.displayName}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientSelector;
